import { Alert } from "reactstrap";
import useRecords from "../../../api/api-hooks/records/useRecords";

export default function GlobalInstructionsMessage() {
  const { records } = useRecords({
    moduleAPIName: "BrieGPTSettings",
    staleTime: Infinity,
  });

  if (!records?.length) return null;

  return (
    <Alert
      color="warning"
      className="tw:py-2 tw:px-3 tw:text-[14px] tw:flex tw:gap-4 tw:rounded"
    >
      <i className="mdi mdi-earth tw:text-3xl" />
      <div className="tw:max-w-md">
        This chat follows global instructions set by the cloud administrator.
      </div>
    </Alert>
  );
}
